/* !!! This is code generated by Prisma. Do not edit directly. !!! */ /* eslint-disable */ // biome-ignore-all lint: generated file
// @ts-nocheck 
/*
* This file exports all enum related types from the schema.
*
* 🟢 You can import this file directly.
*/ export const TokenType = {
    RESET_PASSWORD: 'RESET_PASSWORD'
};
export const MembershipTokenType = {
    INVITE: 'INVITE'
};
export const OrganizationBillingType = {
    STANDARD: 'STANDARD',
    AD_HOC_CUSTOM: 'AD_HOC_CUSTOM'
};
export const OrganizationSubscriptionStatus = {
    INCOMPLETE: 'INCOMPLETE',
    INCOMPLETE_EXPIRED: 'INCOMPLETE_EXPIRED',
    TRIALING: 'TRIALING',
    ACTIVE: 'ACTIVE',
    PAST_DUE: 'PAST_DUE',
    CANCELED: 'CANCELED',
    UNPAID: 'UNPAID'
};
export const ApplicationPlatform = {
    IOS: 'IOS',
    ANDROID: 'ANDROID',
    WEB: 'WEB',
    STRIPE: 'STRIPE',
    PADDLE: 'PADDLE',
    PROMOTIONAL: 'PROMOTIONAL'
};
export const MembershipRole = {
    OWNER: 'OWNER',
    ADMIN: 'ADMIN',
    USER: 'USER',
    EDITOR: 'EDITOR',
    READER: 'READER',
    ANALYST: 'ANALYST'
};
export const GlobalRole = {
    SUPERADMIN: 'SUPERADMIN',
    CUSTOMER: 'CUSTOMER'
};
export const PaddleEnvironment = {
    live: 'live',
    test: 'test'
};
export const PaywallPresentationStyle = {
    FULLSCREEN: 'FULLSCREEN',
    MODAL: 'MODAL',
    PUSH: 'PUSH',
    NO_ANIMATION: 'NO_ANIMATION',
    DRAWER: 'DRAWER'
};
export const ShowPaywallOption = {
    EXPLICIT: 'EXPLICIT',
    ON_FIRST_LAUNCH: 'ON_FIRST_LAUNCH',
    ON_NTH_LAUNCH: 'ON_NTH_LAUNCH'
};
export const PaywallDismissal = {
    NORMAL: 'NORMAL',
    DISABLED: 'DISABLED'
};
export const PresentationCondition = {
    CHECK_USER_SUBSCRIPTION: 'CHECK_USER_SUBSCRIPTION',
    ALWAYS: 'ALWAYS'
};
export const FeatureGating = {
    GATED: 'GATED',
    NON_GATED: 'NON_GATED'
};
export const ReRouteBackButton = {
    ENABLED: 'ENABLED',
    DISABLED: 'DISABLED'
};
export const GameControllerSupport = {
    ENABLED: 'ENABLED',
    DISABLED: 'DISABLED'
};
export const IntroductoryOfferEligibility = {
    AUTOMATIC: 'AUTOMATIC',
    ALWAYS_ELIGIBLE: 'ALWAYS_ELIGIBLE',
    ALWAYS_INELIGIBLE: 'ALWAYS_INELIGIBLE'
};
export const PaywallTemplateType = {
    GLOBAL: 'GLOBAL',
    UNLISTED: 'UNLISTED',
    ORGANIZATION: 'ORGANIZATION'
};
export const TriggerExperimentTemplateType = {
    GLOBAL: 'GLOBAL',
    ORGANIZATION: 'ORGANIZATION'
};
export const OnDeviceCache = {
    ENABLED: 'ENABLED',
    DISABLED: 'DISABLED'
};
export const IsScrollEnabled = {
    ENABLED: 'ENABLED',
    DISABLED: 'DISABLED'
};
export const WebCheckoutDestination = {
    EXTERNAL: 'EXTERNAL',
    IN_APP_BROWSER: 'IN_APP_BROWSER',
    PAYMENT_SHEET: 'PAYMENT_SHEET',
    PAYWALL: 'PAYWALL'
};
export const LocalizationType = {
    SIMPLE: 'SIMPLE',
    ADVANCED: 'ADVANCED'
};
export const TextPaywallResourceVersionVariantVersionStatus = {
    UNVERIFIED: 'UNVERIFIED',
    NORMAL: 'NORMAL',
    REVIEWED: 'REVIEWED'
};
export const SurveyPresentationCondition = {
    ON_MANUAL_CLOSE: 'ON_MANUAL_CLOSE',
    ON_PURCHASE: 'ON_PURCHASE'
};
export const WebPaywallTriggerType = {
    ON_LOAD: 'ON_LOAD',
    ON_ELEMENT_CLICK: 'ON_ELEMENT_CLICK'
};
export const ElementSelectorType = {
    CSS: 'CSS',
    TEXT: 'TEXT'
};
export const ApplicationUserEventName = {
    ALIASED: 'ALIASED',
    PAYWALL_ASSIGNED: 'PAYWALL_ASSIGNED'
};
export const LocalizationFileUploadStatus = {
    STARTING: 'STARTING',
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED'
};
export const NotificationPlanType = {
    SMS: 'SMS',
    EMAIL: 'EMAIL',
    PUSH: 'PUSH'
};
export const Platform = {
    IOS: 'IOS'
};
export const EntitlementType = {
    SERVICE_LEVEL: 'SERVICE_LEVEL'
};
export const PolymorphicRelationType = {
    NONE: 'NONE',
    PAYWALL: 'PAYWALL',
    TRIGGER: 'TRIGGER'
};
export const TriggerExperimentVariantOptimization = {
    NONE: 'NONE',
    UCB1_BANDIT: 'UCB1_BANDIT'
};
export const VariantType = {
    HOLDOUT: 'HOLDOUT',
    TREATMENT: 'TREATMENT'
};
export const ETLDestinationCompression = {
    NONE: 'NONE',
    GZIP: 'GZIP'
};
export const SubscriptionEventPeriodType = {
    NORMAL: 'NORMAL',
    TRIAL: 'TRIAL',
    INTRO: 'INTRO',
    PROMO: 'PROMO',
    PREPAID: 'PREPAID',
    PROMOTIONAL: 'PROMOTIONAL'
};
export const SubscriptionEventCancelReason = {
    UNSUBSCRIBE: 'UNSUBSCRIBE',
    BILLING_ERROR: 'BILLING_ERROR',
    DEVELOPER_INITIATED: 'DEVELOPER_INITIATED',
    PRICE_INCREASE: 'PRICE_INCREASE',
    CUSTOMER_SUPPORT: 'CUSTOMER_SUPPORT',
    UNKNOWN: 'UNKNOWN'
};
export const SubscriptionEventEnvironment = {
    PRODUCTION: 'PRODUCTION',
    SANDBOX: 'SANDBOX'
};
export const SubscriptionEventStore = {
    APP_STORE: 'APP_STORE',
    GOOGLE_PLAY: 'GOOGLE_PLAY',
    STRIPE: 'STRIPE'
};
export const IntegrationType = {
    webhook: 'webhook',
    integration: 'integration'
};
